import React, { useState } from 'react'
import { Button, CollapsibleHeader, FormGrid, FormGroup, Label, Select, Separator, Title } from '../../style'
import { ChevronDown, ChevronUp } from 'lucide-react'
import DeadlinesSection from '../Deadlines'
import HeatTreamentSection from '../HeatTreatment'
import PricesSection from '../Prices'

const ProductSection: React.FC = () => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(true)
  
  return(
    <>
      <CollapsibleHeader onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
        <Title>Adicionar produto</Title>
        <Button>
          {isDetailsOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </Button>
      </CollapsibleHeader>
      {isDetailsOpen && (
      <>
        <FormGrid style={{ marginTop: '16px' }}>
          <FormGroup>
            <Label>Produto</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>NCM</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Formato</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Diâmetro</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Espessura</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
        </FormGrid>
        <FormGrid>
          <FormGroup>
            <Label>Comprimento</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Acabamento</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Peso</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Especificações</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Quantidade</Label>
            <Select>
              <option>Selecione</option>
            </Select>
          </FormGroup>
        </FormGrid>
        <Separator/>
        <DeadlinesSection />
        <Separator />
        {/* <HeatTreamentSection /> 
        <Separator /> */}
        <PricesSection />
      </>
      )}
    </>
  )
}

export default ProductSection